module.exports = __webpack_public_path__ + "static/img/logo_powered_horizontal.4d3f5e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_powered_horizontal.png
// module id = I7uR
// module chunks = 94